interface EnvConfig {
    apiUrl: string;
    appTitle: string;
    isDevelopment: boolean;
    isProduction: boolean;
}

function getEnvVar(key: keyof ImportMetaEnv, defaultValue?: string): string {
    const value = import.meta.env[key];

    if (!value && !defaultValue) {
        throw new Error(`Environment variable ${key} is not defined`);
    }

    return value || defaultValue || '';
}

export const env: EnvConfig = {
    apiUrl: getEnvVar('VITE_API_URL', 'http://localhost:7979/api/v1'),
    appTitle: getEnvVar('VITE_APP_TITLE', '단어장 관리자'),
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
};

// 환경 변수 검증
export function validateEnv(): void {
    const required: (keyof ImportMetaEnv)[] = ['VITE_API_URL'];

    const missing = required.filter(key => !import.meta.env[key]);

    if (missing.length > 0) {
        throw new Error(
            `Missing required environment variables: ${missing.join(', ')}\n` +
            'Please check your .env file.'
        );
    }
}
